import { ComponentType } from "svelte";

import BarcodeIcon from "../../components/Icons/BarcodeIcon.svelte";
import QrCodeIcon from "../../components/Icons/QRCodeIcon.svelte";

export enum REWARDS_QR_CODE_TYPES {
    barcode_1d = "barcode_1d",
    barcode_2d = "barcode_2d",
}

export const REWARDS_QR_CODE_TOOLTIP: Record<REWARDS_QR_CODE_TYPES, string> = {
    [REWARDS_QR_CODE_TYPES.barcode_1d]: "barcode_tooltip",
    [REWARDS_QR_CODE_TYPES.barcode_2d]: "qr_code_tooltip",
};

export const REWARDS_QR_CODE_DESCRIPTION: Record<
    REWARDS_QR_CODE_TYPES,
    string
> = {
    [REWARDS_QR_CODE_TYPES.barcode_1d]: "barcode_description",
    [REWARDS_QR_CODE_TYPES.barcode_2d]: "qr_code_description",
};

export const REWARDS_QR_CODE_DOWNLOAD: Record<REWARDS_QR_CODE_TYPES, string> = {
    [REWARDS_QR_CODE_TYPES.barcode_1d]: "barcode_download",
    [REWARDS_QR_CODE_TYPES.barcode_2d]: "qr_code_download",
};

export const REWARDS_QR_CODE_ICONS: Record<
    REWARDS_QR_CODE_TYPES,
    ComponentType
> = {
    [REWARDS_QR_CODE_TYPES.barcode_1d]: BarcodeIcon,
    [REWARDS_QR_CODE_TYPES.barcode_2d]: QrCodeIcon,
};

export const REWARDS_QR_CODE_ICONS_VIEWBOX: Record<
    REWARDS_QR_CODE_TYPES,
    string
> = {
    [REWARDS_QR_CODE_TYPES.barcode_1d]: "0 0 24 18",
    [REWARDS_QR_CODE_TYPES.barcode_2d]: "0 0 24 24",
};

export const REWARDS_QR_DOWNLOAD_IMAGE_WIDTH: Record<
    REWARDS_QR_CODE_TYPES,
    number
> = {
    [REWARDS_QR_CODE_TYPES.barcode_1d]: 200,
    [REWARDS_QR_CODE_TYPES.barcode_2d]: 244,
};

export const REWARDS_QR_DOWNLOAD_IMAGE_HEIGHT: Record<
    REWARDS_QR_CODE_TYPES,
    number
> = {
    [REWARDS_QR_CODE_TYPES.barcode_1d]: 120,
    [REWARDS_QR_CODE_TYPES.barcode_2d]: 244,
};

export const REWARDS_QR_CANVAS_WIDTH = 500;
export const REWARDS_QR_CANVAS_HEIGHT = 320;
export const REWARDS_QR_SHOP_LOGO_WIDTH = 200;
export const REWARDS_QR_SHOP_LOGO_HEIGHT = 100;

export interface DownloadImageOptions {
    logo: string | null;
    description: string;
    shopDomain: string;
}
